module.exports = __webpack_public_path__ + "img/4.134c43ca.png";